import {
  IsNumber,
  IsPositive,
  IsString
} from 'class-validator';

export class GiftCardTopupRequest {
  @IsString()
  cardNumber: string;

  @IsNumber()
  @IsPositive()
  amount: number;

  posDeviceId?: number;

  employeeId?: number;

  inStoreCardPayment?: number;
}
